import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useWalletAccount from './use-wallet-account.js';
import createActivityItemSelector from '../flux/tx-log/selectors/create-activity-item.js';

function useActivityItem(id: string) {
  const walletAccount = useWalletAccount();

  const assetName = useMemo(() => {
    const parts = id.split('.');

    if (parts.length > 2) {
      // Swap ids contain an additional prefix in front of the asset.
      return parts[1];
    }

    return parts[0];
  }, [id]);

  return useSelector(
    createActivityItemSelector({ assetName, walletAccount, id }),
  );
}

export default useActivityItem;
